<template>
  <el-container class="tags-view-container">
    <div class="reuse-tab">
      <swiper :options="swiperOption" class="reuse-tab-wrap">
         <swiper-slide style="min-width:50px;width: 50px;height: 50px;line-height:50px">
            <div class="fold" >
            <i   :class="menuIcon" @click="setCollapse"></i>
          </div>
        </swiper-slide>
        <swiper-slide v-for="item in expertTableRoutes" :key="item.name">
          <router-link 
            class="reuse-tab-item"
            :class="item.path === $route.path ? 'active' : expertActiveName"
            :to="{ name: item.name, query: item.query, params: item.params}">
            <span v-if="item.name ==='reportQuery'">{{item.query.title}}</span>
            <span v-else>{{item.meta.title}}</span>
            <span class="el-icon-close" v-if="expertTableRoutes.length - 1 > 0" @click.prevent.stop="close(item.name)"/>
          </router-link>
        </swiper-slide>
     </swiper>
    </div>
  </el-container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  export default {
    components: { swiper, swiperSlide },
    name: 'explorer',
    data () {
      return {
        swiperOption: {
        slidesPerView: 'auto',
        initialSlide: 0,
        effect: 'slide',
        spaceBetween: 1,
        preventClicks: false,
        freeMode: true,
        mousewheel: {
          sensitivity: 1.5,
        },
      },
     }
    },

    computed: {
      ...mapGetters(['expertTableRoutes', 'expertActiveName', 'isCollapse']),
      activeName: {
        get () {
          return this.$store.state.expert.activeName
        },
        set (val) {
          this.$store.commit('set_expert_active_name', val)
        }
      },
      menuIcon () {
        return this.isCollapse ? 'el-icon-s-unfold'  :'el-icon-s-fold'
      }
    },
    methods: {
       setCollapse () {
        this.$store.commit('SET_ISCOLLAPSE', !this.isCollapse)
      },
      close (routeName) {
        this.$store.commit('close_expert_tab', {routeName: routeName, vm:this, newRouteName:''})
      }
    }
  }
</script>
<style lang="scss" scoped>
a:visited {
  color:#666
}
.swiper-slide {
  width: auto;
  min-width: 126px;
  display: flex;
  height: 50px;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  color: #666;
}
.reuse-tab-wrap {
  bottom: 0;
  left: 0;
  user-select: none;
  height: 50px;
  // background: #EEF4F9;
  font-size: 14px;
  color: #8c98ae;
  display: flex;
  align-items: center;
  overflow: hidden;
  .reuse-tab-item {
    box-sizing: border-box;
    width: auto;
    height: 50px;
    min-width: 126px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1em;
    margin-right: 1px;
    position: relative;
    white-space: nowrap;
    > i {
      color: #3963bc;
    }
    .el-icon-close {
      opacity: 0;
      position: absolute;
    }
    &:visited {
      color: #8c98ae;
    }
     &:hover {
      background: #f5f5f5;
      border-top: 2px solid #f46722;
      color: #333 !important;
      // border: none;
      font-weight: bold;

      > i {
        color: #fff;
      }

      .el-icon-close {
        position: absolute;
        display: inline-block;
        width: 18px;
        height: 18px;
        top: 0;
        right: 0;
        opacity: 1;
        border-radius: 0 0 0 14px;
        background: rgba(255, 255, 255, 0.3);

        &::before {
          font-size: 18px;
          position: absolute;
          right: -1px;
          transform: scale(0.7);
        }
      }
    }
  }
}
.active {
  box-sizing: border-box;
  height: 50px;
  // color: #ffffff !important;
  background: #f5f5f5;
  border-top: 2px solid #f46722;
  color: #333 !important;
  // border: none;
  font-weight: bold;
  position: relative;
  > i {
      color: #fff;
    }

  .el-icon-close {
    position: absolute;
    display: inline-block;
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    opacity: 1 !important;
    border-radius: 0 0 0 14px;
    background: rgba(255, 255, 255, 0.3);

    &::before {
      font-size: 18px;
      position: absolute;
      right: -1px;
      transform: scale(0.7);
    }
  }
}
.reuse-tab-wrap {
  height: 50px;
  border-bottom: 1px solid #dae1ed;
  border-top: 1px solid #dae1ed;
  background: #fff;
}
.reuse-tab {
  position: relative;
  width: 100%;
  .contextmenu {
    margin: 0;
    background: #ffffff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #596c8e;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 10px 20px;
      cursor: pointer;
      &:hover {
        background: #f5f5f5;
        // color: #6182c9;
        font-weight: bold;
      }
    }
  }
}
</style>
